import { createSelector } from 'reselect'

import { getOfferingActualsValueTypes } from 'partner360/helpers/offerings/programOfferings'

import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitOfferings } from './selectCockpitOfferings'

export { ACTUALS_VALUE_TYPES_ORDER as COCKPIT_METRIC_ORDER } from 'partner360/helpers/offerings/programOfferings'

/** The offering-scoped metric options `CockpitMetrics` renders. With no offering selected
 *  (the "all offerings rolled up" case, same convention as `selectCockpitFinSobRows`), falls
 *  back to the union of every offering's `ActualsValueTypes` rather than showing nothing. */
export const selectAvailableCockpitMetrics = createSelector(
  [selectCockpitOfferings, selectCockpitOffering],
  getOfferingActualsValueTypes
)
